import { ref } from "vue";

const activeMenu = ref(null);

export function useHeaderNavigation() {
  const openMenu = (menuName) => {
    activeMenu.value = menuName;
  };

  const closeMenu = () => {
    activeMenu.value = null;
  };

  const toggleMenu = (menuName) => {
    if (activeMenu.value === menuName) {
      activeMenu.value = null;
    } else {
      activeMenu.value = menuName;
    }
  };

  const isMenuOpen = (menuName) => {
    return activeMenu.value === menuName;
  };

  return {
    activeMenu,
    openMenu,
    closeMenu,
    toggleMenu,
    isMenuOpen,
  };
}
